/**
 * =============================================================================
 *  CHU THICH DI THEO TRANG CUA NO - CHO NAY LA CHO TINH NANG SE HONG THAT
 * =============================================================================
 *
 *  `Annotation.pageIndex` la chi so trang cua TAI LIEU GOC. So do trang
 *  (PagePlan) co the da sap xep lai, xoa bot, nhan doi hoac chen them trang.
 *  Tep xuat ra duoc dung tu so do do, nen chi so trang trong tep KHONG con la
 *  chi so trang cua ban goc.
 *
 *  Ba hanh vi bat buoc, va ca ba deu duoc chot bang test:
 *
 *    SAP XEP LAI  - chu thich o trang 5 phai di theo trang 5 toi vi tri moi.
 *                   Ghi no vao "trang thu 5 cua tep ket qua" la ghi len mot
 *                   trang hoan toan khac.
 *    XOA TRANG    - chu thich tren trang bi xoa phai BIEN MAT. Khong co trang
 *                   nao de no bam vao, va day sang trang ke ben la bia dat.
 *    NHAN DOI     - mot trang xuat hien hai lan trong so do thi chu thich cua
 *                   no xuat hien tren CA HAI ban. Do la nghia dung cua "chu
 *                   thich thuoc ve trang", va bo di mot ban la mat du lieu.
 *
 *  Chu y ve DO XOAY: o trang co the mang rotationDelta. /Rect cua chu thich nam
 *  trong he toa do CHUA XOAY cua trang, va trinh xem ap /Rotate cho CA trang ke
 *  ca chu thich. Nen khong duoc bien doi /Rect theo do xoay - lam vay la xoay
 *  hai lan. Day la ly do o day khong co phep bien doi hinh hoc nao.
 */
import type { Annotation } from '@pdfeditor/types';
import { ORIGINAL_DOC_ID, type PagePlan } from '../pages/plan';

export interface AnnotationPlacement {
  annotation: Annotation;
  /** Chi so trang trong TEP KET QUA. */
  targetPageIndex: number;
}

export interface PlacementResult {
  placements: AnnotationPlacement[];
  /** Chu thich khong con trang nao de bam vao - trang cua no da bi xoa. */
  dropped: Annotation[];
}

/**
 * Chieu chu thich tu khong gian trang GOC sang khong gian trang cua TEP KET QUA.
 *
 * `plan` bo trong nghia la tep ket qua giu nguyen thu tu trang goc (khong co
 * thao tac trang nao), khi do chi so trang giu nguyen.
 */
export function placeAnnotations(
  annotations: readonly Annotation[],
  plan?: PagePlan,
): PlacementResult {
  const placements: AnnotationPlacement[] = [];
  const dropped: Annotation[] = [];

  if (!plan) {
    for (const annotation of annotations) {
      placements.push({ annotation, targetPageIndex: annotation.pageIndex });
    }
    return { placements, dropped };
  }

  // Chi so trang goc -> cac vi tri no dang chiem trong so do. Mot trang co the
  // xuat hien 0 lan (da xoa), 1 lan, hoac nhieu lan (nhan doi).
  const targets = new Map<number, number[]>();
  plan.forEach((slot, slotIndex) => {
    if (slot.docId !== ORIGINAL_DOC_ID) return;
    if (slot.sourcePageIndex === null) return; // trang trang moi chen
    const list = targets.get(slot.sourcePageIndex);
    if (list) list.push(slotIndex);
    else targets.set(slot.sourcePageIndex, [slotIndex]);
  });

  for (const annotation of annotations) {
    const slots = targets.get(annotation.pageIndex);
    if (!slots || slots.length === 0) {
      dropped.push(annotation);
      continue;
    }
    for (const targetPageIndex of slots) {
      placements.push({ annotation, targetPageIndex });
    }
  }

  // Ghi theo thu tu trang giup /Annots cua tung trang giu dung thu tu them vao,
  // va lam cho hai lan luu cho ra hai luong byte giong het nhau.
  placements.sort((a, b) => a.targetPageIndex - b.targetPageIndex);
  return { placements, dropped };
}
